<div class="row mt-2">
    <div class="col-12">
        <div class="card">
            <div class="card-header d-flex">
                <h5 class="card-title my-auto mb-auto">Proposal Templates</h5>
                <button (click)="createProposalTemplate()" type="button" class="btn btn-primary ms-auto">
                    <fa-icon class="button-icon-left" [icon]="faPlus"></fa-icon>
                    <span>New</span>
                </button>
                <button type="button" class="btn btn-primary ms-2" (click)="getProposalTemplate();" ngbTooltip="Refresh" aria-label="Refresh">
                    <fa-icon [icon]="faRotateRight" [animation]="isRefreshing ? 'spin' : null"></fa-icon>
                </button>
            </div>
            <div class="card-body">
                <div class="table-responsive">
                    <table *ngIf="!isMobile" class="table table-hover">
                        <thead>
                            <tr>
                                <th>Name</th>
                                <th>Created By</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let pro of templateProposals" (click)="editTemplateProposal(pro)">
                                <td>{{pro.groupTemplateName}}</td>
                                <td>{{pro.createdByName}}</td>
                                <td>
                                    <button (click)="deleteProposalTemplate(pro, $event)" type="button" class="btn btn-danger">
                                        <fa-icon [icon]="faTrash"></fa-icon>
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    <div class="scrollable" *ngIf="isMobile">
                      <ul class="list-group">
                          <li *ngFor="let pro of templateProposals" class="list-group-item list-group-item-action">
                              <div class="d-flex list-group-container">
                                  <div>
                                      <strong style="font-size: 1.2rem;">{{pro.groupTemplateName}}</strong>
                                      <br/>
                                      <small class="text-muted">Created By: {{pro.createdByName}}</small>
                                      <div class="list-button">
                                        <button (click)="deleteProposalTemplate(pro)" type="button" class="btn btn-danger w-100">
                                          Delete
                                        </button>
                                        <button (click)="editTemplateProposal(pro)" type="button" class="btn btn-primary w-100">
                                          Edit
                                        </button>
                                      </div>
                                  </div>
                              </div>
                          </li>
                          <li *ngIf="templateProposals.length == 0" class="list-group-item">No Template Proposals</li>
                      </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
